import { useRouter } from "next/router";

const LOCALE_DEFAULT = "es-CL";

export function getLocale() {
  return useRouter().locale ?? LOCALE_DEFAULT;
}
